'use strict'

import App from "./App";

class Articles {
    
    constructor() {
        
    }
    
    init () {
        $('form[name="search"]').on('submit', (e) => {
            e.preventDefault();
            $('.articles-results ul').find('li').remove();
            $('input[name="page"]').val(1);
            this.find();
        });
        $('.article__more a').on('click', (e) => {
            e.preventDefault();
            this.find();
        });
        $('select[name="category"]').on('change', (e) => {
            e.preventDefault();
            $('.articles-results ul').find('li').remove();
            $('input[name="page"]').val(1);
            this.find();
        });
    }

    find () {
        $('.article__more a').addClass('article-loading');
        App.loading();
        $.ajax({
            url: $('form[name="search"]').attr('action'),
            type : "POST",
            dataType : 'json',
            data : $('form[name="search"]').serialize(),
            success : (data) => {
                App.endLoading();
                $('.article__more a').removeClass('article-loading');
                if (data.q === ''){ $('#message-result').hide() } else { $('#message-result').show() }
                $.var({
                    q:data.q,
                    found_rows:data.found_rows
                })
                $('input[name="page"]').val(data.paginator.next);
                if(!data.paginator.is_next){
                    $('.article__more a').hide();
                } else {
                    $('.article__more a').show();
                }
                this.render(data.docs);
            },
            error: function(xhr, resp, text) {
                App.endLoading();
                $('.article__more a').removeClass('article-loading');
                console.log(xhr, resp, text);
            }
        });
    }

    render (docs) {
        docs.forEach(doc => {
            $('.articles-results ul').append(
                $('<li/>').append(
                    $('<a/>')
                    .attr('href', doc.link)
                    .addClass('article-box article-box--green')
                    .append($('<span/>')
                        .addClass('article-box__border-left')
                        .css('background-color', doc.category_color))
                    .append(
                        $('<div/>')
                        .addClass('article-box__wrap')
                        .append($('<span>').addClass('article-box__category mb-3').text(doc.category))
                        .append($('<span>').addClass('article-box__title').text(doc.title))
                    ))
            );
        });
    }
}

export default Articles;